<template>
    <el-dialog
        class="add-shipping-rule-store-selector"
        :visible.sync="storeVisible"
        :close-on-click-modal="true"
        @closed="closeDialog"
        append-to-body
        width="800px"
    >
      <div class="title">Select Store</div>
       <div class="platform-list">
        <label style="color:#666">Marketplace: </label>
        <a href="#" v-for="item in platforms" :key="item.id" :class="platformSelected === item.id && 'active' || ''" :data-value="item.id" @click="selectPlatform">{{item.name}}</a>
      </div>
      <div class="selector-container">
        <div class="selector-container-left">
          <el-input v-model="filter" placeholder="Search Store" size="small" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <label class="check-all"><input type="checkbox" ref="checkAllDom" @click="checkAll" :checked="stores.filter(item => platformSelected === '0' || item.platform_id.toString() === platformSelected).length === stores.filter(item => platformSelected === '0' || item.platform_id.toString() === platformSelected).filter(item => selected.includes(item.value)).length"> All ({{stores.filter(item => platformSelected === '0' || item.platform_id.toString() === platformSelected).length}})</label>
          <div class="selector-container-list">
            <template v-for="item in stores"><label v-if="(!filter || item.label.toLowerCase().includes(filter.toLowerCase())) && ('0' === platformSelected || item.platform_id.toString() === platformSelected)" :key="item.value"><input type="checkbox" :value="item.value" @click="checkMe" :checked="selected.includes(item.value)"> {{item.label}}</label></template>
          </div>
        </div>
        <div class="selector-container-right">
          <el-input v-model="filterSelected" placeholder="Search Store" size="small" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <div style="margin: 16px 0">Selected: <span style="color:#635cff">{{selected.length}}</span> <span v-if="(selected.length > 1)" style="display: inline-block; margin-left: 10px">(<a href="#" style="color:#635cff" @click="clearAll">Cancel All</a>)</span></div>
          <div class="selector-container-list">
            <template v-for="item in stores">
            <label v-if="(selected.includes(item.value) && (!filterSelected || item.label.toLowerCase().includes(filterSelected.toLowerCase())))" :key="item.value"><input type="checkbox" checked :value="item.value" @click="uncheckMe"> {{item.label}}</label>
            </template>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary"
            @click="save"
                >Confirm</el-button
            >
            <el-button size="small" @click="closeDialog"
                >Cancel</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            filter: '',
            filterSelected: '',
            selected: [],
            platformSelected: '0',
            platforms: [
                {
                    id: '0',
                    name: 'All',
                },
                {
                    id: '3',
                    name: 'Shopify',
                },
                {
                    id: '4',
                    name: 'Shoplazza',
                },
                {
                    id: '8',
                    name: 'Shopline',
                },
                {
                    id: '9',
                    name: 'Etsy',
                },
            ],
        };
    },
    methods: {
        checkMe(event) {
            const { target } = event
            const { value, checked } = target

            if (!checked) {
                for (let i = 0; i < this.selected.length; i++) {
                    if (this.selected[i] === value) {
                        return this.$nextTick(() => this.selected.splice(i, 1))
                    }
                }
            } else {
                this.$nextTick(() => {
                    this.selected.push(value)
                })
            }
        },
        uncheckMe(event) {
            const { target } = event
            const { value } = target

            for (let i = 0; i < this.selected.length; i++) {
                if (this.selected[i] === value) {
                    // this.$refs.checkAllDom.checked = false
                    return this.$nextTick(() => this.selected.splice(i, 1))
                }
            }
        },
        checkAll(event) {
            const { target } = event
            const { checked } = target

            if (checked) {
                if (this.platformSelected === '0') {
                    this.selected = this.stores.map(item => item.value.toString())
                } else {
                    this.stores.filter(item => item.platform_id.toString() === this.platformSelected).forEach(item => !this.selected.includes(item.value.toString()) && this.selected.push(item.value.toString()))
                }
            } else {
                if (this.platformSelected === '0') {
                    this.selected = []
                } else {
                    this.stores.filter(item => item.platform_id.toString() === this.platformSelected).forEach(item => {
                        const indexOf = this.selected.indexOf(item.value)
                        indexOf > -1 && this.selected.splice(indexOf, 1)
                    })
                }
            }
        },
        clearAll(event) {
            event.preventDefault()
            this.$nextTick(() => {
                this.selected = []
            })
        },
        selectPlatform(event) {
            event.preventDefault()
            const { target } = event
            this.platformSelected = target.getAttribute('data-value')
        },
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.filter = ''
            this.filterSelected = ''
            this.$emit("update:storeVisible", false)
        },
        /**
         *  保存
         */
        save() {
            this.$emit("update:storesSelected", this.selected)
            this.$emit("update:storeVisible", false)
        },
    },
    props: {
        storeVisible: Boolean,
        tableItem: Object,
        funcName: String,
        stores: Array,
        storesSelected: Array
    },
    watch: {
        storeVisible: {
            handler() {
                this.selected = [...this.storesSelected]
            },
            immediate: true,
            deep: true
        }
    },
};
</script>
<style lang="scss">
.add-shipping-rule-store-selector {
    .el-dialog__header {
      display: none;
    }
    .title {
        font-weight: bold;
        margin-top: 10px;
        font-size: 120%;
    }
    .platform-list {
        margin: 16px 0;
        display: flex;
        column-gap: 16px;

        a {
            outline: none;
            color: #606266;
            text-decoration: none;

            &.active {
                color: #635cff;
            }
        }
    }
    .selector-container {
        display: flex;
        justify-content: space-between;
        margin: 20px 0;

        &-left {
            border: 1px solid #DCDFE6;
            padding: 20px;
            height: 300px;
            width: 330px;
            overflow: auto;

            .check-all {
                margin: 16px 0 10px 0;
                display: block;
                user-select: none;
            }
        }

        &-right {
            border: 1px solid #DCDFE6;
            padding: 20px;
            height: 300px;
            width: 330px;
            overflow: auto;
        }

        &-list {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 10px 16px;
            user-select: none;
        }
    }
}
</style>
